/** Every user-facing string of the conference page's "Auto enrichment for past leads" card (AutoEnrichPastLeads.tsx). */
export const AUTO_ENRICH_PAST_COPY = {
  title: 'Auto enrichment for past leads',
  helper:
    "This starts the Auto enrichment run by hand for leads already captured at this show. It is not the Enrich button on a lead: it does no web research and only fills a missing phone, checking this company's own data first (rep notes, discovery answers, earlier captures of the same person), then Apollo, which uses credits. Leads that already have a phone, or that someone already ran Enrich on, are skipped. It works in the background at about 25 leads a minute, after any new scans, and within the daily Apollo limit, so a large show can take more than a day. You can close this page.",
  run: 'Run auto enrichment',
  runAgain: 'Run again',
  stop: 'Stop',
  confirmRun: (company: string, n: number) =>
    `Queue ${company}'s ${n} lead${n === 1 ? '' : 's'} without a phone at this show for Auto enrichment? Apollo lookups use credits.`,
  confirmStop: 'Stop queuing this show? Leads already being checked finish; the rest are left as they are.',
  flagOff: 'Turn on Auto enrichment for this company first (Companies → the company → Edit).',
  archived: 'This company is archived.',
  noLeadsWithoutPhone: 'Every lead from this company at this show already has a phone.',
  queuedTag: 'Queued',
  queuedBy: (when: string, by: string) => `Queued ${when} by ${by}`,
  started: 'Queued for Auto enrichment. Progress shows here as the leads are checked.',
  stopped: 'Stopped.',
  noCompanies: 'No company has access to this show yet.',
  refresh: 'Refresh',
} as const;
